import React from "react";

export default function Plus () {
    return (
        <i className={'icon icon--plus'}/>
    )
}
